import { Skeleton } from '../common';

// The column while its one read is in flight.
//
// THE HEADING IS REAL AND THE ROWS ARE NOT, which is the whole point: the
// column's width and its title are known before the request returns, so drawing
// them immediately stops the modal reflowing when the answer lands. Two
// placeholder rows because most households have one or two people — a count
// that is usually right beats an empty box that is always wrong.
export function AccessColumnSkeleton() {
  return (
    <aside className="ob-access">
      <div className="ob-pane-head">
        <div>
          {/* The heading the loaded column keeps — Self-service, since 2026-10-10 — so the words never swap (2026-10-11). */}
          <div className="ob-title">Self-service</div>
          <div className="ob-sub">What the customer did, and what it needs from us</div>
        </div>
      </div>
      <div className="ac-list" aria-busy="true">
        {[0, 1].map((i) => (
          <div key={i} className="ac-row">
            {/* The loaded row's own grid: avatar, the name's line and the state's line, chevron. */}
            <div className="ac-hd">
              <span className="bl-block" style={{ width: 32, height: 32, borderRadius: '50%' }} />
              <span className="ac-who">
                <Skeleton variant="line" />
                <Skeleton variant="line" />
              </span>
              <span className="bl-block" style={{ width: 22, height: 22, borderRadius: 'var(--radius-sm)' }} />
            </div>
          </div>
        ))}
      </div>
    </aside>
  );
}
